import clsx from 'clsx';

export const getMenuItemClassName =
  (styles = {}, defaultClassName) =>
  ({ hover, disabled }) =>
    disabled
      ? clsx(styles.menuItemDisabled, defaultClassName)
      : hover
        ? clsx(styles.menuItemHover, defaultClassName)
        : clsx(styles.menuItem, defaultClassName);
